import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-mifiel',
  templateUrl: './mifiel.component.html',
  styleUrls: ['./mifiel.component.scss'],
})
export class MifielComponent implements OnInit {

  templateSuffix = environment.templateSuffix;
  title = '';

  constructor(
    private matRef: MatDialogRef<MifielComponent>,
    @Inject('Window') private window: any,
    @Inject(MAT_DIALOG_DATA) private data: any,
    @Inject(DOCUMENT) private document:any,
  ) {}

  ngOnInit(): void {

    const url = environment.miFiel.base;
    this.title = this.data.title;

    if (!this.document.getElementById('mifiel-js')) {
      let c: any = this.document.createElement('script'),
        o: any =this.document.getElementsByTagName('script')[0];
      c.type = 'text/javascript';
      c.id = 'mifiel-js';
      c.async = !0;
      c.src = url;
      o.parentNode.insertBefore(c, o);
    }

    this.window.mifiel.widget({
      widgetId: this.data.idDocument,
      appendTo: 'mifiel-widget',
      successBtnText: 'Finalizar',
      color: 'fe5000',
      onSuccess: {
        // here the code you want to execute after the signer successfully sign and click the button could be an url  'mifiel.com' or a function() {}
        callToAction: () => {
          this.close();
        },
      },
      onError: {
        // here the code you want to execute after an error occurs, could be an url  'mifiel.com' or a function() {}
        callToAction: () => {
          this.close();
        },
      },
    });
  }

  close() {
    this.matRef.close(true);
  }
}
